import {
  getMeta,
  setMeta,
} from '../db/jobsDb.js';

const META_KEY = 'sync_freshness_v1';

export type SyncFreshness = {
  referenceAt: string | null;
  referenceError: string | null;
  jobsAt: string | null;
  jobsError: string | null;
  receiptsAt: string | null;
  receiptsError: string | null;
  complianceAt: string | null;
  complianceError: string | null;
  expensesAt: string | null;
  expensesError: string | null;
};

const empty: SyncFreshness = {
  referenceAt: null,
  referenceError: null,
  jobsAt: null,
  jobsError: null,
  receiptsAt: null,
  receiptsError: null,
  complianceAt: null,
  complianceError: null,
  expensesAt: null,
  expensesError: null,
};

export async function getSyncFreshness(): Promise<SyncFreshness> {
  const raw = await getMeta(META_KEY);
  if (!raw) return { ...empty };
  try {
    return { ...empty, ...(JSON.parse(raw) as Partial<SyncFreshness>) };
  } catch (err) {
    console.warn('sync freshness meta corrupt', err);
    return { ...empty };
  }
}

export async function patchSyncFreshness(
  patch: Partial<SyncFreshness>,
): Promise<SyncFreshness> {
  const cur = await getSyncFreshness();
  const next = { ...cur, ...patch };
  await setMeta(META_KEY, JSON.stringify(next));
  return next;
}

export function formatLastUpdated(iso: string | null): string {
  if (!iso) return 'never';
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return 'unknown';
  return new Date(t).toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** True when we have a recorded error, or never successfully refreshed. */
export function isReferenceStale(f: SyncFreshness): boolean {
  return Boolean(f.referenceError) || !f.referenceAt;
}

export function hasMergeStale(f: SyncFreshness): boolean {
  return Boolean(
    f.jobsError || f.receiptsError || f.complianceError || f.expensesError,
  );
}
